import { Tax } from './product';
import { Currency } from './currency';
import { UnitOfMeasure } from './unit-of-measure';
import { Product } from './product';

export interface SaleOrderLineTaxRel {
  id: number;
  saleOrderLineId: number;
  taxId: number;
  tax: Tax;
}

export interface SaleOrderLine {
  id: number;
  name: string;
  sequence: number;
  quantity: number;
  priceUnit: number;
  discount: number;
  priceSubtotal: number;
  taxAmount: number | null;
  priceTotal: number | null;
  isActive: boolean;
  saleOrderId: number;
  productId?: number;
  product?: Product;
  unitOfMeasureId?: number;
  unitOfMeasure?: UnitOfMeasure;
  currencyId: number;
  currency?: Currency;
  budgetLineId?: number | null;
  budgetLine?: {
    id: number;
    name: string;
  } | null;
  customerNote?: string | null;
  taxes: SaleOrderLineTaxRel[];
}

export interface BudgetLine extends SaleOrderLine {
  description: string;
  /** Precio unitario NETO, sin impuestos y antes de descuento. */
  price: number;
  /** Importe CON impuestos incluidos. */
  amount: number;
  /** Importe NETO con el descuento ya aplicado; suma al Subtotal (CEC-586). */
  netAmount?: number;
  unitOfMeasureName?: string;
}

